import {Event} from "../../dtos/eventResponse"

export const getDeliveryEventOfItemId = (
	deliveryDetails: Map<string, Event[]>,
	lineItemId: string
): Event | undefined => {
	return deliveryDetails.get(lineItemId)
		? deliveryDetails
				.get(lineItemId)!
				.filter(
					(x: Event) =>
						x.eventProperties &&
						x.eventProperties.details &&
						x.eventProperties.details.length > 0 &&
						x.eventProperties.details[0].additionalData &&
						x.eventProperties.details[0].additionalData.trackingId &&
						x.eventProperties.details[0].additionalData.trackingUrl
				)[0]
		: undefined
}

export const getDeliveryURLOfItemID = (
	deliveryDetails: Map<string, Event[]>,
	lineItemId: string
): string => {
	const event = getDeliveryEventOfItemId(deliveryDetails, lineItemId)
	if (
		event &&
		event.eventProperties &&
		event.eventProperties.details &&
		event.eventProperties.details.length > 0 &&
		event.eventProperties.details[0] &&
		event.eventProperties.details[0].additionalData &&
		event.eventProperties.details[0].additionalData.trackingUrl
	) {
		return event.eventProperties.details[0].additionalData.trackingUrl
	} else return ""
}
